var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-base text-center padding-10"},[_vm._v("\n\n  "+_vm._s(_vm.settings)+"\n  "),_c('vue-apex-charts',{attrs:{"type":"radialBar","height":"180","options":_vm.chartOptions,"series":_vm.theSeries}}),_c('div',{style:({
    backgroundColor: _vm.settings.value.color,
    marginLeft: '30px',
    marginRight: '30px',
    color: 'white',
    padding: '5px',
    fontWeight: 'bold'
  })},[_c('p',[_vm._v("Done: "+_vm._s(_vm.settings.value.counts[0]))]),_c('p',[_vm._v("Pending: "+_vm._s(_vm.settings.value.counts[1]))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }